import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const SplitScreenReveal = ({ data = {} }) => {
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setRevealed(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative h-full w-full overflow-hidden bg-white">
      {/* Left Panel */}
      <motion.div
        initial={{ x: 0 }}
        animate={{ x: revealed ? '-50%' : 0 }}
        transition={{ duration: 1, ease: 'easeInOut' }}
        className="absolute top-0 left-0 w-1/2 h-full bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center"
      >
        <div className="text-white text-center px-8">
          <h3 className="text-3xl font-bold mb-2">Problem</h3>
          <p className="text-lg opacity-90">{data.problemText || 'Complex challenges'}</p>
        </div>
      </motion.div>

      {/* Right Panel */}
      <motion.div
        initial={{ x: 0 }}
        animate={{ x: revealed ? '50%' : 0 }}
        transition={{ duration: 1, ease: 'easeInOut' }}
        className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center"
      >
        <div className="text-white text-center px-8">
          <h3 className="text-3xl font-bold mb-2">Solution</h3>
          <p className="text-lg opacity-90">{data.solutionText || 'Simple answers'}</p>
        </div>
      </motion.div>

      {/* Center Content (Revealed) */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: revealed ? 1 : 0, scale: revealed ? 1 : 0.8 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        className="absolute inset-0 flex items-center justify-center pointer-events-none"
      >
        <div className="bg-white rounded-lg shadow-2xl p-8 text-center max-w-md">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">
            {data.centerTitle || 'Your Product'}
          </h2>
          <p className="text-gray-600">
            {data.centerText || 'Bridges the gap perfectly'}
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default SplitScreenReveal;

